<template>
	<div>
		<v-card class="config">
			<h3>{{title}} Configuration</h3>
			<v-row>
				<v-col align="center">
					<div>
						<v-btn class="action" @click="getConf()">
							1. {{(this.data && this.data.length > 0) ? 'Refresh':'Generate'}} export
						</v-btn>
					</div>
				</v-col>
				<v-col align="center">
					<v-btn class="export" @click="jsonExport" :disabled="!data || data.length === 0">
						2. Download export
						<v-icon>mdi-download</v-icon>
					</v-btn>
					<a id="downloadAnchorElem" style="display:none"></a>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-file-input
						height="20"
						v-bind:label="`Import file for ${title}`"
						@change="onFileChange($event)"
					/>
				</v-col>
				<v-col align="center">
					<div>
						<v-btn class="action" @click="importFile()">
							Import
							<v-icon>mdi-upload</v-icon>
						</v-btn>
					</div>
				</v-col>
			</v-row>
		</v-card>
		<v-snackbar v-model="snackbar.display" :timeout="snackbar.timeout" auto-height="true">
			<span v-html="$sanitize(snackbar.text)"></span>
			<template v-slot:action="{ attrs }">
				<v-btn
					color="pink"
					text
					v-bind="attrs"
					@click="hideErrors()"
				>Close</v-btn
				>
			</template>
		</v-snackbar>
	</div>
</template>


<script>
import { api } from '@/utils/api';

export default {
	props: ['title', 'type'],

	data () {
		return {
			data: [],
			file: [],
			snackbar: {
				display: false,
				text: '',
				timeout: 0
			}
		};
	},
	methods: {
		async jsonExport () {
			const dataStr = JSON.stringify(this.data);
			const dataUri = 'data:text/json;charset=utf-8,'+ encodeURIComponent(dataStr);
			const link = document.getElementById('downloadAnchorElem');
			link.setAttribute('href', dataUri);
			link.setAttribute('download', `${this.title}.json`);
			link.click();
		},
		async getConf () {
			this.data = await api.get(`${this.type}Export`);
		},
		async onFileChange (file) {
			this.file = file;
		},
		async importFile () {
			if (!this.file) {
				this.snackbar.text = 'Choose a file to import.';
				this.snackbar.display = true;
				return;
			}
			await this.readFile(this.file, this.type);
		},
		async readFile (file) {
			const reader = new FileReader();
			reader.onload = async e => {
				let json = {};
				try {
					json = JSON.parse(e.target.result);
				} catch (e) {
					// error due to invalid JSON file
					this.snackbar.text = `JSON file can't be loaded for ${this.type} configuration due to the following error : ${e.message}`;
					this.snackbar.display = true;
					return;
				}
				const res = await api.post(`${this.type}Import`, json);
				if (res.importStatus === 400 && res.errorList !== {}) {
					// error due to invalid schema
					this.snackbar.text = `Error importing configuration for ${this.type} :<br>`;
					Object.keys(res.errorList).forEach((k) => {
						this.snackbar.text += `- For object number ${parseInt(k)+1} in your file :<br><ul>`;
						for (let i = 0; i < res.errorList[k].errors.length; i++) {
							this.snackbar.text += `<li>${res.errorList[k].errors[i].stack.replace('instance.', '')}</li>`;
						}
						this.snackbar.text += '</ul>';
					});

					this.snackbar.display = true;

				} else {
					this.snackbar.text = `${this.type} configuration was updated successfully.`;
					this.snackbar.display = true;
				}
			};
			reader.readAsText(file);
		},
		hideErrors () {
			if (this.snackbar.display) {
				this.snackbar.display = false;
			}
		}
	},
	async mounted () {
		this.$el.addEventListener('click', this.hideErrors);
	}
};

</script>


<style lang="scss" scoped>

.v-icon {
	font-size: 1em;
	margin-left: 10px;
}

.config {
	margin-top: 20px;
	h3 {
		padding: 15px;
	}
}

</style>

